var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"ma-2"},[_c('v-card-title',[_vm._v(" 修改推薦代碼 ")]),_c('v-card-text',[_c('v-divider'),(_vm.isValueSetted)?_c('item-form',_vm._b({attrs:{"codeEditable":false,"loading":_vm.loading},on:{"submit":_vm.submit}},'item-form',_vm.form,false)):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }